import { Chip, Modal } from '@/ui/primitives';
import { Stack } from '@/ui/layout';
import type { HistoryItem } from '../schemas';

interface Props {
  item: HistoryItem | null;
  onClose: () => void;
}

export function HistoryDetailModal({ item, onClose }: Props) {
  const open = item !== null;
  if (!item) return <Modal open={false} onOpenChange={onClose} title="" children={null} />;

  const isDecision = item.kind === 'decision';
  const tag = isDecision ? 'DECISÃO' : 'LIÇÃO';
  const tone = isDecision ? 'info' : 'ok';

  return (
    <Modal open={open} onOpenChange={(v) => !v && onClose()} title={item.title} size="lg">
      <Stack gap="md">
        <div className="flex flex-wrap items-center gap-2">
          <Chip tone={tone} size="sm">
            {tag}
          </Chip>
          {isDecision && (
            <Chip tone="neutral" size="sm">
              {item.date}
            </Chip>
          )}
          {!isDecision && item.section && (
            <Chip tone="neutral" size="sm">
              {item.section}
            </Chip>
          )}
        </div>

        <p className="text-sm text-text-2 whitespace-pre-wrap leading-relaxed">
          {item.description || 'Sem descrição.'}
        </p>
      </Stack>
    </Modal>
  );
}
